import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import React, { useState } from "react"; // Import hooks
import { HelmetProvider } from "react-helmet-async";
import Home from './pages/Home';
import InglesPresencial from "./pages/ingles-presencial";
import About from './pages/About';
import Contact from './pages/Contact';
import './style.css';
import InglesOnline from './pages/ingles-online';
import Linguahub from './pages/LinguaHub';
import WorkWithUs from './pages/WorkWithUs';
import Cursos from './pages/Cursos';
import CertificacionesIngles from "./pages/Certificaciones-Ingles";
import ExamenUbicacion from "./pages/ExamenUbicacion";
import PlacementTest from "./pages/PlacementTest";
import AboutUs from "./pages/AboutUs";
import SpanishClasses from "./pages/SpanishClasses";
import SummerCamp from "./pages/SummerCamp";
import SpanishFees from "./pages/SpanishFees";
import Services from "./pages/Services";
import OurLocation from "./pages/OurLocation";
import Kinder from "./pages/courses/Kinder";
import Ninos from "./pages/courses/Ninos";
import Jovenes from "./pages/courses/Jovenes";
import Adultos from "./pages/courses/Adultos";
import Intensivo from "./pages/courses/Intensivo";
import Privadas from "./pages/courses/Privadas";
import Empresas from "./pages/courses/Empresas";
import Certificaciones from "./pages/courses/Certificaciones";
import ScrollToTop from "./ScrollToTop";
import CourseFinderForm from "./pages/CourseFinderForm";
import PartnerWithUsSpanish from "./PartnerWithUsSpanish";
import Gracias from "./components/Gracias";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import BlogAdmin from "./pages/BlogAdmin";



export default function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [openSubmenus, setOpenSubmenus] = useState({});

  const handleMenuToggle = () => { setMenuOpen(o => !o); setOpenSubmenus({}); };
  const handleLinkClick = () => { setMenuOpen(false); setOpenSubmenus({}); };

  const toggleSubmenu = (key, e) => {
    if (window.innerWidth <= 900) {
      e.preventDefault();
      setOpenSubmenus(prev => ({ ...prev, [key]: !prev[key] }));
    }
  };

  return (
    <div className="app-container">
    <HelmetProvider>
    <Router>
    <ScrollToTop />
    <nav className="navbar">
          {/* Home Logo */}
          <Link to="/" className="home-button">
            <img src="/logo.webp" alt="Home" className="home-logo" />
          </Link>

          {/* Mobile Menu Button */}
          <button 
            className="menu-button" 
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu" /* ✅ Fix: Improve accessibility */
          >
            ☰
          </button>

          {/* Menu Items */}
          <div className={`menu-items ${menuOpen ? "open" : ""}`}>
            <div className={`menu-item${openSubmenus.ingles ? ' open' : ''}`}>
              <Link to="/" onClick={(e) => toggleSubmenu('ingles', e)}>Aprende Inglés</Link>
              <div className="submenu">
                <Link to="/" onClick={handleLinkClick} className="submenu-link">Presencial</Link>
                <Link to="/ingles-online" onClick={handleLinkClick} className="submenu-link">Online</Link>
                <Link to="/Certificaciones-Ingles" onClick={handleLinkClick} className="submenu-link">Certificaciones</Link>
                <Link to="/Examen-de-ubicacion" onClick={handleLinkClick} className="submenu-link">Examen de Ubicación</Link>
                <Link to="/EncuentraTuCurso" onClick={handleLinkClick} className="submenu-link">Encuentra Tu Curso</Link>
              </div>
            </div>
            <div className={`menu-item${openSubmenus.spanish ? ' open' : ''}`}>
              <Link to="/Spanish" onClick={(e) => toggleSubmenu('spanish', e)}>Learn Spanish</Link>
              <div className="submenu">
                <Link to="/AboutUs" onClick={handleLinkClick} className="submenu-link">About Us</Link>
                <Link to="/Spanish" onClick={handleLinkClick} className="submenu-link">Classes</Link>
                <Link to="/Spanish-Fees" onClick={handleLinkClick} className="submenu-link">Fees</Link>
                <Link to="/Placement-Test" onClick={handleLinkClick} className="submenu-link">Placement Test</Link>
                <Link to="/Services" onClick={handleLinkClick} className="submenu-link">Services</Link>
                <Link to="/PartnerWithUsSpanish" onClick={handleLinkClick} className="submenu-link">Partner With Us</Link>
                <Link to="/OurLocation" onClick={handleLinkClick} className="submenu-link">Our Location</Link>
              </div>
            </div>
            <Link to="/Cursos" onClick={handleLinkClick}>Cursos</Link>
            <Link to="/SummerCamp" onClick={handleLinkClick}>Curso de Verano</Link>
            <Link to="/LinguaHub" onClick={handleLinkClick}>LinguaHub</Link>
            <Link to="/Sobre-Nosotros" onClick={handleLinkClick}>Sobre Nosotros</Link>
            <Link to="/blog" onClick={handleLinkClick}>Blog</Link>

            <div className={`menu-item${openSubmenus.contacto ? ' open' : ''}`}>
              <Link to="/contacto" className="nav-cta" onClick={(e) => toggleSubmenu('contacto', e)}>Contáctanos</Link>
              <div className="submenu">
                <Link to="/contacto" onClick={handleLinkClick} className="submenu-link">Contáctanos</Link>
                <Link to="/work-with-us" onClick={handleLinkClick} className="submenu-link">Trabaja con nosotros</Link>
              </div>
            </div>
          </div>
        </nav>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/" element={<InglesPresencial />} />
        <Route path="/ingles-online" element={<InglesOnline />} />
        <Route path="/Certificaciones-Ingles" element={<CertificacionesIngles />} />
        <Route path="/LinguaHub" element={<Linguahub />} />
        <Route path="/ingles-presencial/Certificaciones" element={<CertificacionesIngles />} />
        <Route path="/Examen-de-ubicacion" element={<ExamenUbicacion />} />
        <Route path="/SummerCamp" element={<SummerCamp />} />
        <Route path="/Services" element={<Services />} />
        <Route path="/Our-Location" element={<ExamenUbicacion />} />
        <Route path="/Placement-Test" element={<PlacementTest />} />
        <Route path="/Sobre-Nosotros" element={<About />} />
        <Route path="/Spanish" element={<SpanishClasses />} />
        <Route path="/Spanish-Fees" element={<SpanishFees />} />
        <Route path="/PartnerWithUsSpanish" element={<PartnerWithUsSpanish />} />
        <Route path="/OurLocation" element={<OurLocation />} />
        <Route path="/AboutUs" element={<AboutUs />} />
        <Route path="/Cursos" element={<Cursos />} />
        <Route path="/contacto" element={<Contact />} />
        <Route path="/courses/Kinder" element={<Kinder />} />
        <Route path="/courses/Ninos" element={<Ninos />} />
        <Route path="/courses/Jovenes" element={<Jovenes />} />
        <Route path="/courses/Adultos" element={<Adultos />} />
        <Route path="/courses/Intensivo" element={<Intensivo />} />
        <Route path="/courses/Privadas" element={<Privadas />} />
        <Route path="/courses/Empresas" element={<Empresas />} />
        <Route path="/courses/PreparacionExamen" element={<Certificaciones />} />
        <Route path="/EncuentraTuCurso" element={<CourseFinderForm />} />
        <Route path="/gracias" element={<Gracias />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="https://www.linguahub.culturlingua.com"/>
        <Route path="/blog-admin" element={<BlogAdmin />} />
        <Route path="/work-with-us" element={<WorkWithUs />} />
      </Routes>
    </Router>
    
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-grid">
            <div className="footer-brand">
              <span className="footer-brand-logo">Cultur<span>lingua</span></span>
              <p>Más de 20 años formando hablantes reales de inglés en Jalisco. Presencial en Tlaquepaque y online desde cualquier lugar.</p>
              <div className="footer-social">
                <a href="https://www.facebook.com/Culturlinguagdl" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
                </a>
                <a href="https://www.instagram.com/culturlingua_gdl/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
                </a>
                <a href="https://www.linkedin.com/company/culturlingua-gdl/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></svg>
                </a>
              </div>
            </div>
            <div className="footer-col">
              <h4>Inglés</h4>
              <a href="/Cursos">Cursos Presenciales</a>
              <a href="/ingles-online">Clases Online</a>
              <a href="/courses/Empresas">Para Empresas</a>
              <a href="/Certificaciones-Ingles">Certificaciones</a>
              <a href="/Examen-de-ubicacion">Examen de Ubicación</a>
            </div>
            <div className="footer-col">
              <h4>Español</h4>
              <a href="/Spanish">Clases de Español</a>
              <a href="/Spanish-Fees">Precios</a>
              <a href="/Placement-Test">Placement Test</a>
              <a href="/OurLocation">Nuestra Ubicación</a>
            </div>
            <div className="footer-col">
              <h4>Institución</h4>
              <a href="/Sobre-Nosotros">Sobre Nosotros</a>
              <a href="/contacto">Contacto</a>
              <a href="/LinguaHub">LinguaHub</a>
              <a href="/SummerCamp">Curso de Verano</a>
              <a href="/work-with-us">Trabaja con Nosotros</a>
            </div>
          </div>
          <div className="footer-bottom">
            <span>© 2025 Culturlingua. Todos los derechos reservados.</span>
            <span>📍 Reforma 31, Tlaquepaque, Jalisco · 📞 +52 33 3344 9139</span>
          </div>
        </div>
      </footer>
    
   <a href="https://wa.me/5213333449139?text=Hola%2C%20quisiera%20más%20información%20sobre%20los%20cursos." class="whatsapp-float" target="_blank" aria-label="Chat on WhatsApp">
  <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" />
</a>
</HelmetProvider>
      </div>

      

    
  );
}
